import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import Navbar from '../components/Navbar';
import './ProtectedPage.css';

const ProfilePage = () => {
    const { user, isAuthenticated, isLoading } = useAuth0();

    if (isLoading) return <div>Loading...</div>;

    if (!isAuthenticated) return <div>Please log in to view this page.</div>;

    const getInitials = (name?: string) => {
        if (!name) return '??';
        return name
            .split(' ')
            .map(part => part[0])
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    const Avatar = ({ user }: { user: any }) => {
        const [imgError, setImgError] = React.useState(false);

        if (!user?.picture || imgError) {
            return (
                <div style={{
                    width: '100px',
                    height: '100px',
                    borderRadius: '50%',
                    border: '2px solid #6366f1',
                    background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '2rem',
                    fontWeight: 'bold',
                    color: '#818cf8',
                    textShadow: '0 2px 4px rgba(0,0,0,0.5)'
                }}>
                    {getInitials(user?.name)}
                </div>
            );
        }

        return (
            <img
                src={user.picture}
                alt={user.name}
                onError={() => setImgError(true)}
                style={{ width: '100px', height: '100px', borderRadius: '50%', border: '2px solid #6366f1', objectFit: 'cover' }}
            />
        );
    };

    return (
        <div className="protected-page">
            <Navbar />
            <div className="page-content">
                <div className="page-header">
                    <h1 className="page-title">Profile</h1>
                    <p className="page-subtitle">Manage your account information</p>
                </div>

                <div className="page-card">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '2rem', marginBottom: '2rem' }}>
                        <Avatar user={user} />
                        <div>
                            <h2 style={{ fontSize: '1.8rem', marginBottom: '0.5rem' }}>{user?.name}</h2>
                            <span style={{
                                background: 'rgba(99, 102, 241, 0.2)',
                                color: '#818cf8',
                                padding: '0.3rem 0.8rem',
                                borderRadius: '20px',
                                fontSize: '0.9rem'
                            }}>
                                Active User
                            </span>
                        </div>
                    </div>

                    <div className="card-section">
                        <span className="card-label">Email Address</span>
                        <div className="card-value">{user?.email}</div>
                    </div>

                    <div className="card-section">
                        <span className="card-label">Email Verified</span>
                        <div className="card-value">{user?.email_verified ? 'Yes ✅' : 'No ❌'}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfilePage;
